var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 33.295 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc79d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9237fc"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "file",
    className: "cls-1",
    d: "M79.788,42H59.617a6.57,6.57,0,0,1-6.563-6.562V6.563A6.57,6.57,0,0,1,59.617,0H79.788a6.57,6.57,0,0,1,6.563,6.563V27.234a1.641,1.641,0,0,1-3.281,0V6.563a3.285,3.285,0,0,0-3.281-3.281H59.617a3.285,3.285,0,0,0-3.281,3.281V35.438a3.285,3.285,0,0,0,3.281,3.281H79.788a3.285,3.285,0,0,0,3.281-3.281,1.641,1.641,0,0,1,3.281,0A6.57,6.57,0,0,1,79.788,42Zm0-30.516a1.641,1.641,0,0,0-1.641-1.641h-16.9a1.641,1.641,0,0,0,0,3.281h16.9A1.641,1.641,0,0,0,79.788,11.484Zm0,6.563a1.641,1.641,0,0,0-1.641-1.641h-16.9a1.641,1.641,0,1,0,0,3.281h16.9A1.641,1.641,0,0,0,79.788,18.047Zm-6.635,6.563a1.641,1.641,0,0,0-1.641-1.641H61.249a1.641,1.641,0,1,0,0,3.281H71.512A1.641,1.641,0,0,0,73.153,24.609Z",
    transform: "translate(-53.055)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFile);
export default __webpack_public_path__ + "static/media/icon-file.5a3286a17bb6057f8c6c02d0b0c57cf0.svg";
export { ForwardRef as ReactComponent };